export default {
  state: {
    progress: false,
    progress_message: '',
    is_allowed_to_cancel: false,
    abortControllers: {},
    active_cancel_key: null,
    confirm_modal: false,
    send_puzzle_modal: false,
    send_hunting_words_modal: false,
    puzzle_form_modal: false,
    forgot_password_modal: false,
    export_file_modal: false,
    puzzle_edit_question_modal: false,
    puzzle_question_delete_modal: false,
    import_file_modal: false,
    save_template_modal: false,
    unsaved_changes_modal: false,
    cancelCallback: null,
  },
  mutations: {
    toggle(state, toggleType) {
      state[toggleType] = !state[toggleType];
    },
    setToggle(state, data) {
      state[data.type] = data.bool;
    },
    setProgress(state, payload) {
      state.progress = payload.status;
      state.progress_message = payload.message || '';
      state.is_allowed_to_cancel = payload.canCancel || false;

      if (!payload.status) {
        state.active_cancel_key = null;
        state.cancelCallback = null;
      }
    },
    setIsAllowedToCancel(state, bool) {
      state.is_allowed_to_cancel = bool;
    },
    setAbortController(state, { key, controller }) {
      state.abortControllers[key] = controller;
    },
    clearAbortController(state, key) {
      if (state.abortControllers[key]) delete state.abortControllers[key];
    },
    setActiveCancelKey(state, key) {
      state.active_cancel_key = key;
    },
    clearAllAbortControllers(state) {
      state.abortControllers = {};
      state.active_cancel_key = null;
    },
    setCancelCallback(state, fn) {
      state.cancelCallback = fn;
    },
    clearCancelCallback(state) {
      state.cancelCallback = null;
    },
  },
  actions: {
    toggle({ commit }, toggleType) {
      commit('toggle', toggleType);
    },
    setToggle({ commit }, data) {
      commit('setToggle', data);
    },
    cancelRequest({ state, commit }) {
      if (state.cancelCallback) {
        state.cancelCallback();
        commit('clearCancelCallback');
      }

      const key = state.active_cancel_key;
      if (key) {
        const controller = state.abortControllers[key];
        if (controller) {
          controller.abort();
          commit('clearAbortController', key);
        }
      }

      commit('setProgress', { status: false, message: '', canCancel: false });
    },
    showLoader({ commit }, message = '') {
      commit('setProgress', { status: true, message });
    },
    hideLoader({ commit }) {
      commit('setProgress', { status: false, message: '' });
    },
    startCancellable({ commit }, { message = '', onCancel }) {
      commit('setCancelCallback', onCancel);
      commit('setProgress', { status: true, message, canCancel: true });
    },
  },
};
